import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ItemAnalysisRow;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import OutcomeList from '@instructure/outcomes-ui/es/containers/OutcomeList';
import { MetricGroup } from '@instructure/ui-metric';
import { Heading } from '@instructure/ui-heading';
import { ScreenReaderContent, PresentationContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { RichContentRenderer } from '@instructure/quiz-rce';
import Card from '../../../../common/components/shared/Card';
import ExpandButton from '../../../../common/components/shared/ExpandButton';
import Spinner from '../../../../common/components/shared/spinner/Spinner';
import AnswerFrequencySummary from '../AnswerFrequencySummary';
import QuintileDistribution from '../../charts/QuintileDistribution';
import Legend from '../../charts/Legend';
import Caption from '../../Caption';
import MetricsListItem from '../../MetricsListItem';
import t from '@instructure/quiz-i18n/es/format-message';
import { liveRegion, withI18nSupport, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var ItemAnalysisRow = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ItemAnalysisRow = /*#__PURE__*/function (_withI18nSupport) {
  function ItemAnalysisRow() {
    var _this;
    _classCallCheck(this, ItemAnalysisRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ItemAnalysisRow, [].concat(args));
    _defineProperty(_this, "toggleExpanded", function () {
      _this.props.toggleExpanded(_this.props.itemId);
      var _this$props = _this.props,
        position = _this$props.position,
        expanded = _this$props.expanded;
      var text = t("{\n      expanded, select,\n      false {Expanded question {position, number}}\n      other {Collapsed question {position, number}}\n    }", {
        position: position,
        expanded: expanded
      });
      _this.props.screenreaderNotification(text);
    });
    return _this;
  }
  _inherits(ItemAnalysisRow, _withI18nSupport);
  return _createClass(ItemAnalysisRow, [{
    key: "renderExpandButton",
    value: function renderExpandButton() {
      var _this$props2 = this.props,
        position = _this$props2.position,
        expanded = _this$props2.expanded;
      var title = t("{\n      expanded, select,\n      false {Expand question {position, number} details}\n      other {Collapse question {position, number} details}\n    }", {
        position: position,
        expanded: expanded
      });
      return jsx(ExpandButton, {
        onClick: this.toggleExpanded,
        title: title,
        isExpanded: expanded,
        "data-automation": "sdk-reporting-expand-button"
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var position = this.props.position;
      var interactionType = this.props.itemAnalysis.interactionTypeName();
      var pointsPossible = this.props.itemAnalysis.pointsPossible;
      var separator = ' | ';
      return jsx("div", {
        css: this.props.styles.headerRow
      }, jsx("div", {
        css: this.props.styles.headerText
      }, jsx(Heading, {
        level: "reset",
        as: "h3"
      }, jsx(ScreenReaderContent, null, t('Question {position, number}', {
        position: position
      })), interactionType, jsx(PresentationContent, null, separator), t('{pointsPossible, number} points possible', {
        pointsPossible: pointsPossible
      }))), this.props.itemAnalysis.isPresent() && this.renderExpandButton());
    }
  }, {
    key: "renderStem",
    value: function renderStem() {
      return jsx(RichContentRenderer, {
        customStyles: this.props.styles.stem,
        content: this.props.itemAnalysis.itemBody
      });
    }
  }, {
    key: "defaultMetricsList",
    value: function defaultMetricsList() {
      var _this2 = this;
      var mean = t.rich('{score}<0>/{possible, number} pts</0>', {
        0: function _(_ref) {
          var children = _ref.children;
          return jsx("span", {
            key: "mean",
            css: _this2.props.styles.metricNote
          }, children);
        },
        score: this.props.itemAnalysis.meanScore(this.locale) || 0,
        possible: this.props.itemAnalysis.pointsPossible
      });
      return jsx(MetricGroup, null, jsx(MetricsListItem, {
        key: "difficultyIndex",
        renderLabel: t('Difficulty Index'),
        renderValue: this.props.itemAnalysis.difficultyIndex(this.locale),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "discriminationIndex",
        renderLabel: t('Discrimination Index'),
        renderValue: this.props.itemAnalysis.discriminationIndex(this.locale),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "rpb",
        renderLabel: t('RPB'),
        renderValue: this.props.itemAnalysis.pointBiserial(this.locale),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "meanEarnedScore",
        renderLabel: t('Mean Earned Score'),
        renderValue: mean,
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }));
    }
  }, {
    key: "renderMetrics",
    value: function renderMetrics() {
      var list = React.Children.count(this.props.children) === 0 ? this.defaultMetricsList() : jsx(MetricGroup, null, this.props.children);
      return jsx("div", {
        css: this.props.styles.metrics
      }, list);
    }
  }, {
    key: "renderAnswerAnalysisChart",
    value: function renderAnswerAnalysisChart() {
      if (this.props.itemAnalysis.choiceInfo().size === 0) {
        return;
      }
      return jsx("div", {
        css: this.props.styles.answerTableSection
      }, jsx(Caption, {
        text: t('Answer Frequency Summary')
      }, jsx(AnswerFrequencySummary, {
        itemAnalysis: this.props.itemAnalysis
      })));
    }
  }, {
    key: "renderAnswerAnalysis",
    value: function renderAnswerAnalysis() {
      if (this.props.expanded) {
        var quintile = this.props.itemAnalysis.quintile();
        return jsx("div", {
          css: this.props.styles.answerAnalysis
        }, this.renderAnswerAnalysisChart(), jsx("div", {
          css: this.props.styles.answerDistributionSection,
          "data-automation": "sdk-reporting-answer-distribution"
        }, jsx(Caption, {
          text: t('Performance by Quintile')
        }, jsx("div", {
          css: this.props.styles.answerDistribution
        }, jsx("div", {
          css: this.props.styles.answerDistributionChart
        }, jsx(QuintileDistribution, {
          visualDistribution: quintile,
          animateDelay: this.props.animateDelay,
          animateDuration: this.props.animateDuration
        })), jsx("div", {
          css: this.props.styles.answerDistributionLegend
        }, jsx(Legend, {
          series: [{
            customStyles: this.props.styles.answerDistributionSwatch,
            label: t('Number of Students')
          }]
        }))))));
      }
    }
  }, {
    key: "renderOutcomeAlignments",
    value: function renderOutcomeAlignments() {
      var _this$props3 = this.props,
        expanded = _this$props3.expanded,
        itemAnalysis = _this$props3.itemAnalysis,
        outcomesEndpoint = _this$props3.outcomesEndpoint,
        outcomesToken = _this$props3.outcomesToken;
      if (expanded && outcomesEndpoint && itemAnalysis.outcomeAlignmentSetGuid) {
        return jsx("div", {
          css: this.props.styles.outcomeAlignments
        }, jsx(Caption, {
          text: t('Outcomes')
        }, jsx(OutcomeList, {
          artifactType: "quizzes.item",
          artifactId: itemAnalysis.itemId,
          alignmentSetId: itemAnalysis.outcomeAlignmentSetGuid,
          host: outcomesEndpoint,
          jwt: outcomesToken,
          emptyText: t('No outcomes are aligned'),
          screenreaderNotification: this.props.screenreaderNotification,
          liveRegion: liveRegion
        })));
      }
    }
  }, {
    key: "renderNotFound",
    value: function renderNotFound() {
      return jsx("div", {
        css: this.props.styles.emptyText
      }, t('No submissions yet'));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.itemAnalysis.isLoaded()) {
        return jsx(Spinner, null);
      }
      var present = this.props.itemAnalysis.isPresent();
      return jsx(Card, {
        key: this.props.itemId,
        css: this.props.styles.itemAnalysisRow
      }, this.renderHeader(), jsx("div", {
        css: this.props.styles.metricsRow
      }, this.renderStem(), present ? this.renderMetrics() : this.renderNotFound()), present && this.renderAnswerAnalysis(), this.renderOutcomeAlignments());
    }
  }]);
}(withI18nSupport(Component)), _defineProperty(_ItemAnalysisRow, "displayName", 'ItemAnalysisRow'), _defineProperty(_ItemAnalysisRow, "componentId", "Quizzes".concat(_ItemAnalysisRow.displayName)), _defineProperty(_ItemAnalysisRow, "propTypes", {
  animateDelay: PropTypes.number,
  animateDuration: PropTypes.number,
  expanded: PropTypes.bool,
  itemAnalysis: ImmutablePropTypes.record.isRequired,
  itemId: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  outcomesEndpoint: PropTypes.string,
  outcomesToken: PropTypes.string,
  screenreaderNotification: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.node),
  locale: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_ItemAnalysisRow, "defaultProps", {
  animateDelay: void 0,
  animateDuration: void 0,
  expanded: false,
  outcomesEndpoint: null,
  outcomesToken: null,
  children: [],
  locale: null
}), _defineProperty(_ItemAnalysisRow, "contextTypes", {
  locale: PropTypes.string
}), _ItemAnalysisRow)) || _class);
export default ItemAnalysisRow;